import gsap from "gsap";

const header = () => {
  const header = document.querySelector(".header");
  const background = document.querySelector(".header-background");
  const footer = document.querySelector(".footer");
  let lastScrollTop = 0;
  let currentScroll = 0;
  let scrollDirection;
  let scrollOffset = 400;
  let isSticky = false;
  let isOffset = false;

  const stick = (el) => {
    el.classList.add("is-sticky");
    isSticky = true;
  };

  const unstick = (el) => {
    el.classList.remove("is-sticky");
    isSticky = false;
  };

  const offset = (el, duration) => {
    gsap.to(el, {
      y: "-100%",
      duration: duration,
    });
    isOffset = true;
  };

  const unoffset = (el, duration) => {
    gsap.to(el, {
      y: 0,
      duration: duration,
      onComplete: () => {
        el.style.transform = "none";
      },
    });
    isOffset = false;
  };

  const showBackground = () => {
    gsap.to(background, {
      opacity: 1,
      duration: 0.3,
    });
  };

  const hideBackground = () => {
    gsap.to(background, {
      opacity: 0,
      duration: 0.3,
    });
  };

  window.addEventListener("scroll", () => {
    currentScroll = window.scrollY;
    scrollDirection = currentScroll > lastScrollTop ? "down" : "up";
    const footerTop = footer.getBoundingClientRect().top;

    if (scrollDirection === "down" && currentScroll > scrollOffset) {
      if (!isSticky) {
        stick(header);
        offset(header, 0);
        hideBackground();
      }
      if (!isOffset) {
        offset(header, 0.3);
        hideBackground();
      }
    }

    if (
      scrollDirection === "up" &&
      isSticky &&
      footerTop > window.innerHeight / 2
    ) {
      if (lastScrollTop - currentScroll > 15) {
        unoffset(header, 0.3);
        showBackground();
      }

      if (currentScroll <= 0) {
        unstick(header);
        hideBackground();
      }
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });
};

export default header;
